export enum CountriesAbbr {
  US = 'US',
}

export const getOnlyCountries = (areSmsNotificationsEnabled: boolean) =>
  areSmsNotificationsEnabled ? [CountriesAbbr.US] : undefined;
